import LegalConsentKeyBuilders from 'forms-utils-lib/legalConsent/lib/LegalConsentKeyBuilders';
import LegalConsentOptions from 'forms-utils-lib/legalConsent/constants/legalConsentOptions';
import getIsLegitimateInterest from 'forms-utils-lib/legalConsent/utils/getIsLegitimateInterest';
import getIsImplicityConsent from 'forms-utils-lib/legalConsent/utils/getIsImplicityConsent';
import getCommunicationConsentCheckboxes from 'forms-utils-lib/legalConsent/utils/getCommunicationConsentCheckboxes';
const buildLegalConsent = ({
  legalConsentOption,
  legalConsentCopy,
  subscriptionDefinitions,
  communicationConsentCheckboxes = []
}) => {
  const isLegitimateInterest = getIsLegitimateInterest(legalConsentOption);
  const isImplicityConsent = getIsImplicityConsent(legalConsentOption);
  const updatedCommunicationConsentCheckboxes = getCommunicationConsentCheckboxes({
    legalConsentCopy,
    subscriptionDefinitions,
    communicationConsentCheckboxes
  });
  if (legalConsentOption === LegalConsentOptions.NONE) {
    return null;
  }
  return LegalConsentKeyBuilders.reduce((acc, keyBuilder) => {
    acc[keyBuilder.key] = keyBuilder.getValue({
      legalConsentOption,
      legalConsentCopy,
      isLegitimateInterest,
      isImplicityConsent,
      communicationConsentCheckboxes: updatedCommunicationConsentCheckboxes
    });
    return acc;
  }, {});
};
export default buildLegalConsent;